import type {
    CloudPaymentsFailResult,
    CloudPaymentsPayOptions,
    CloudPaymentsSuccessResult,
    CloudPaymentsWidget,
} from './types'

type PayWithCloudPaymentsParams = {
    widget: CloudPaymentsWidget
    options: CloudPaymentsPayOptions
    onSuccess: (result: CloudPaymentsSuccessResult) => void
    onFail: (result: CloudPaymentsFailResult) => void
}

export const payWithCloudPayments = ({ widget, options, onSuccess, onFail }: PayWithCloudPaymentsParams) => {
    widget.pay('charge', options, {
        onSuccess: successOptions => {
            onSuccess({
                status: 'success',
                options: successOptions ?? options,
            })
        },
        onFail: (reason, failOptions) => {
            onFail({
                status: 'fail',
                reason: reason || 'Не удалось обработать платеж.',
                options: failOptions ?? options,
            })
        },
    })
}
